<template>
  <v-row
    no-gutters
    class="socioemotional"
  >
    <v-col
      cols="12"
      class="pa-0"
    >
      <edudash-select
        v-model="schoolSelected"
        :items="getTeacherSchools"
        :placeholder="$t('views.socioemotional.school_class_name')"
      />
    </v-col>
    <v-col
      cols="6"
      class="pr-1"
    >
      <edudash-select
        v-model="schoolClassSelected"
        :items="schoolClassesList"
        :placeholder="$t('views.socioemotional.school_class')"
      />
    </v-col>
    <v-col
      cols="6"
      class="pl-1"
    >
      <edudash-select
        v-model="studentSelected"
        :items="studentsList"
        :placeholder="$t('views.socioemotional.student')"
      />
    </v-col>
    <v-col
      cols="12"
    >
      <edudash-graph
        v-if="hasGraphData"
        :graph-data="fillGraphData"
        :datasets="fillGraphDatasets"
      />

      <div
        v-if="!showGraph"
        class="placeholder"
      >
        {{ $t('views.indiscipline_and_health.select_school') }}
      </div>
      <div
        v-if="noGraphDataAvaliable"
        class="placeholder"
      >
        {{ $t('views.indiscipline_and_health.no_data_avaliable') }}
      </div>
    </v-col>
    <v-col
      v-if="hasGraphData"
      cols="12"
      class="occurrence-categories-averages"
    >
      <div class="average-title">
        {{ $t('views.socioemotional.average') }}
      </div>
      <div
        v-for="(category, index) in averageCategories"
        :key="index"
      >
        <div>
          <span class="category-name">{{ category.name }} - </span>
          <span :class="averageColor(category.average)"> {{ category.average }} </span>
        </div>
      </div>
    </v-col>
    <hr>
    <v-col
      cols="12"
    >
      <div
        v-if="hasGraphData"
        class="historical"
        @click="goToOccurrenceHistory"
      >
        {{ $t('views.indiscipline_and_health.see_historical') }}
      </div>
    </v-col>
  </v-row>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import EdudashSelect from '@/components/forms/EdudashSelect.vue';
import EdudashGraph from '@/components/graphs/EdudashGraph.vue';

export default {
  name: 'Socioemotional',
  components: {
    EdudashSelect,
    EdudashGraph,
  },
  data() {
    return {
      schoolSelected: {},
      schoolClassSelected: {},
      studentSelected: {},
      schoolClasses: [],
      students: [],
      graphData: {},
      graphDatasets: [],
      categories: [],
    };
  },
  computed: {
    ...mapGetters([
      'getTeacherSchools',
      'getSchoolClass',
      'getSocioemotionalAlerts',
      'getAverageSocioemotionalOccurrences',
    ]),
    schoolClassesList() {
      return this.schoolClasses.filter((schoolClass) => schoolClass.active);
    },
    studentsList() {
      return this.students;
    },
    fillGraphData() {
      return this.graphData;
    },
    fillGraphDatasets() {
      return this.graphDatasets;
    },
    hasGraphData() {
      return !this.isEmpty(this.schoolSelected) && this.dataIsAvaliable;
    },
    noGraphDataAvaliable() {
      return !this.isEmpty(this.schoolSelected) && !this.dataIsAvaliable;
    },
    showGraph() {
      return !this.isEmpty(this.schoolSelected);
    },
    dataIsAvaliable() {
      if (!this.isEmpty(this.graphData)) {
        const categories = Object.values(this.graphData);
        categories.pop();
        return categories.some((category) => !this.arrayIsEmpty(category));
      }
      return true;
    },
    averageCategories() {
      return this.categories;
    },
  },
  watch: {
    schoolSelected(value) {
      if (value.school_classes[0].name !== 'Todos') {
        value.school_classes.unshift({ name: 'Todos' });
      }
      this.schoolClasses = value.school_classes;
      this.findAlertsInformations(value.id, '', '');
      this.findAveragesInformations(value.id, '', '');
    },
    schoolClassSelected(value) {
      if (value.name !== 'Todos') {
        this.findSchoolClass({ schoolClassId: value.id });
        this.findAlertsInformations(this.schoolSelected.id, value.id, '');
        this.findAveragesInformations(this.schoolSelected.id, value.id, '');
      } else {
        this.students = [{ name: 'Todos' }];
        this.findAlertsInformations(this.schoolSelected.id, '', '');
      }
    },
    studentSelected(value) {
      if (value.name !== 'Todos') {
        this.findAlertsInformations(this.schoolSelected.id, this.schoolClassSelected.id, value.id);
        this.findAveragesInformations(
          this.schoolSelected.id, this.schoolClassSelected.id, value.id,
        );
      } else {
        this.allOptionSelected(value.id);
      }
    },
    getSchoolClass(value) {
      value.students.unshift({ name: 'Todos' });
      this.students = value.students;
    },
    getSocioemotionalAlerts(value) {
      this.graphData = value.graph_data;
      this.graphDatasets = value.graph_datasets;
    },
    getAverageSocioemotionalOccurrences(value) {
      this.categories = value;
    },
  },
  mounted() {
    this.findTeacherSchools();
  },
  methods: {
    ...mapActions([
      'findTeacherSchools',
      'findSchoolClass',
      'findSocioemotionalAlerts',
      'findAverageSocioemotionalOccurrences',
      'findStudentOccurrences',
    ]),
    findAlertsInformations(school, schoolClass, student) {
      this.findSocioemotionalAlerts({
        school_id: school,
        school_class_id: schoolClass,
        student_id: student,
      });
    },
    findAveragesInformations(school, schoolClass, student) {
      this.findAverageSocioemotionalOccurrences({
        school_id: school,
        school_class_id: schoolClass,
        student_id: student,
      });
    },
    allOptionSelected(studentId) {
      if (this.schoolClassSelected === 'Todos') {
        this.findAlertsInformations(this.schoolSelected.id, '', '');
      } else {
        this.findAlertsInformations(this.schoolSelected.id, studentId, '');
      }
    },
    goToOccurrenceHistory() {
      this.$router.push({
        name: 'historicalOccurrences',
        params: {
          backPath: 'alertsIndisciplineAndHealth',
          socioemotional: true,
          studentId: this.studentSelected.id,
        },
        query: {
          by_school: this.schoolSelected.id,
          by_school_class: this.schoolClassSelected.id,
        },
      });
    },
    averageColor(average) {
      if (average >= 4) {
        return 'average good';
      }
      if (average >= 3) {
        return 'average okay';
      }
      return 'average bad';
    },
  },
};
</script>

<style lang="scss">
  .socioemotional {
    @include font-monteserrat-bold;
    color: $color-primary;
    padding: 12px 16px;

    .v-select {
      height: 34px;
    }

    .placeholder {
      @include font-open-sans-bold;
      font-size: $font-size-extra-small;
      text-align: center;
      margin: 20px 0 26px 0;
      color: $text-color-primary;
    }

    .occurrence-categories-averages {
      margin-top: 12px;
      .average-title {
        @include font-open-sans-bold;
        font-size: $font-size-extra-small;
        color: $text-color-category-title;
      }

      .category-name {
        @include font-monteserrat-regular;
        font-size: $font-size-extra-small;
        color: $text-color-primary;
      }

      .average {
        @include font-monteserrat-bold;
        font-size: $font-size-extra-small;
        &.good {
          color: $color-good;
        }
        &.okay {
          color: $color-okay;
        }
        &.bad {
          color: $color-bad;
        }
      }
    }

    .historical {
      @include font-open-sans-bold;
      font-size: $font-size-extra-small;
      color: $secondary-button-color;
      margin: 20px 0 40px 0;
      text-align: center;
    }
  }
</style>
